<template>
    <div>
        <div class="f12" style="color:#000 !important;">系统时间:{{client_time}} / 服务器时间:{{server_time}}</div>
        <div class="wrap mg-center">
            <div class="cl"></div>
            <el-row :gutter="20" style="margin-top:200px;">
                <el-col :span="14">
                    <div class="light">
                        <img src="/images/logo.png" width="500"/>
                    </div>
                    <div class="margin-top light f-lq f40 f-i"></div>
                    <div class="f-thin light f22 margin-top"></div>
                </el-col>
                <el-col :span="10">
                    <div class="bg-light padding-20">
                        <div class="border-bottom brand f-b padding-bottom"> 登录</div>
                        <el-form :model="loginForm" :rules="rules" ref="ruleForm" label-width="auto" class="margin-top">
                            <el-form-item label="" prop="username">
                                <el-input v-model="loginForm.username" placeholder="用户名">
                                    <i slot="prefix" class="el-input__icon el-icon-user"></i>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="" prop="password">
                                <el-input v-model="loginForm.password" show-password placeholder="密码" maxlength="20">
                                    <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="submitForm('ruleForm')" class="block">登录</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: "Login",
    data() {
        return {
            loginForm: {
                username: '',
                password: '',
            },
            //测试数据
            testData:{
                aaa:'',
                bbb:'',
            },
            rules: {
                username: [
                    {required: true, message: '请输入用户名', trigger: 'blur'}
                ],
                password: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                    {min: 1, max: 20, message: '请输入1-20位密码', trigger: 'blur'}
                ]
            },
            client_time:'',
            server_time:''
        };
    },
    created() {
        document.querySelector('body').style.backgroundImage = 'url("/images/bg.jpg")';
        document.querySelector('body').style.backgroundRepeat = 'no-repeat';
        document.querySelector('body').style.backgroundSize = '100% 100%';
    },
    mounted() {
        this.getClientTime();
        this.getServerTime();
    },
    methods: {
        getClientTime(){
            this.client_time = this.$moment().format('YYYY-MM-DD HH:mm:ss');
        },
        getServerTime(){
            let _this = this;
            this.$http.httpPost({
                url: '/Common/getTime',
                datas: null,
                success(res) {
                    console.log(res);
                    _this.server_time = res;
                }
            });
        },
        submitForm(formName) {
            let _this = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    this.$http.httpPost({
                        url:'/Member/login',
                        datas:this.loginForm,
                        success(res){
                            _this.$user.setToken(res.token);
                            _this.$user.setUid(res.id);
                            _this.$user.setUserName(res.username);
                            // _this.$router.replace({path:'/'});

                            if (res.menu) {
                                _this.$utils.sessionSet('menu', JSON.stringify(res.menu));
                            }

                            if (res.rule) {
                                _this.$utils.sessionSet('rule', JSON.stringify(res.rule));
                            }

                            _this.$message.success({message: '登录成功', duration: 2000});
                            _this.$router.replace({path:'/'});
                            // let _routes = _this.$rule.getRoutes();
                            //
                            // console.log(_routes);
                            //
                            // if (_routes) {
                            //     new Promise((resolve, reject) => {
                            //         _this.$router.onReady(() => {
                            //             _this.$router.addRoutes(_routes);
                            //             resolve(_this.$router.replace({path: '/'}));
                            //         });
                            //     });
                            // }
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
    }
}
</script>
